import { post, get, patch, deleted } from 'services';
import routes from './routes';

const ShippingServices = {
  getVinDetails: async (params) => {
    const data = await get(routes.getVinDetails, params);
    return data;
  },
  getBookingRefDetail: async (params) => {
    const data = await get(routes.getBookingRefDetail, params);
    return data;
  },
  createShipping: async (obj) => {
    const data = await post(routes.createShipping, obj);
    return data;
  },
  updateShippingVehicle: async (obj) => {
    const data = await patch(routes.updateShippingVehicle, obj);
    return data;
  },
  updateShipping: async (obj) => {
    const data = await patch(routes.updateShipping, obj);
    return data;
  },
  getShipping: async (params) => {
    const data = await get(routes.getShipping, params);
    return data;
  },
  deleteShipping: async (params) => {
    const data = await deleted(routes.deleteShipping, params);
    return data;
  },
  getExportShippingTracking: async (params) => {
    const data = await get(routes.getExportShippingTracking, params);
    return data;
  },
  getShippingVin: async (params) => {
    const data = await get(routes.getShippingVin, params);
    return data;
  },
  getShippingInfo: async (params) => {
    const data = await get(routes.getShippingInfo, params);
    return data;
  },
  getShippingTracking: async (params) => {
    const data = await get(routes.getShippingTracking, params);
    return data;
  },
  getContainerDetails: async (params) => {
    const data = await get(routes.getContainerDetail, params);
    return data;
  },
  updateContainer: async (obj) => {
    const data = await patch(routes.updateContainer, obj);
    return data;
  },
  updateContainerDates: async (obj) => {
    const data = await patch(routes.updateContainerDates, obj);
    return data;
  },
}

export default ShippingServices